import {
  SET_TRX_GOLD_LIST,
  PROCESSING,
  UPDATE_GOLD_STATUS,
  SET_ACCOUNT_DETAIL,
  GET_ACCOUNT_TRANSACTION,
  SET_ACCOUNT_TRANSACTION,
} from '../actions/types';

import {
  PAGE_SERVICE_PAGE_NUM_TABLE_DEFAULT,
  PAGE_SERVICE_PAGE_SIZE_TABLE_DEFAULT,
  PAGE_SERVICE_PAGE_SIZE_TABLE_ACCOUNT,
} from '../../constant/GoldDefaultVar';

export const initialState = {
  trxList: [],
  trxFilter: {
    page_num: PAGE_SERVICE_PAGE_NUM_TABLE_DEFAULT,
    page_size: PAGE_SERVICE_PAGE_SIZE_TABLE_DEFAULT,
    page_count: 1,
  },
  accountDetail: {},
  trxHistoryList: [],
  trxHistoryFilter: {
    page_num: PAGE_SERVICE_PAGE_NUM_TABLE_DEFAULT,
    page_size: PAGE_SERVICE_PAGE_SIZE_TABLE_ACCOUNT,
    page_count: 1,
  },
  loadingTrx: false,
  loading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case PROCESSING:
      return {
        ...state,
        loading: true,
      };
    case SET_TRX_GOLD_LIST:
      return {
        ...state,
        trxList: action.payload,
        loading: false,
        trxFilter: action.filter,
      };
    case UPDATE_GOLD_STATUS:
      return {
        ...state,
        loading: false,
      };
    case SET_ACCOUNT_DETAIL:
      return {
        ...state,
        accountDetail: action.payload,
        loading: false,
      };
    case GET_ACCOUNT_TRANSACTION:
      return {
        ...state,
        loadingTrx: true,
      };
    case SET_ACCOUNT_TRANSACTION:
      return {
        ...state,
        trxHistoryList: action.payload,
        loadingTrx: false,
        trxHistoryFilter: action.filter,
      };
    default:
      return state;
  }
}
